// ── Márka felvásárlási oldalak ──────────────────────────────────────────────
//
// CSAK két márka: iPhone és Samsung. Ezekre van a kalkulátorban áradat, és
// ezekre van valódi keresési szándék („iPhone felvásárlás Orosháza”).
//
// Honor és Huawei SZÁNDÉKOSAN NINCS: a kalkulátor nem tudja beárazni őket,
// tehát a landing oldal olyan tölcsérbe küldené a látogatót, ami a telefonját
// nem tudja kiszolgálni. Ez rosszabb, mint ha nincs oldal. Amint az árak
// bekerülnek az xlsx-be, ez a fájl bővíthető.

export const MARKA_FELVASARLAS = [
  {
    slug: 'iphone-felvasarlas-oroshaza',
    marka: 'iPhone',
    cim: 'iPhone felvásárlás Orosházán – azonnali készpénz | NorbiPhone',
    leiras: 'Használt iPhone felvásárlás Orosházán azonnali készpénzes kifizetéssel. Töröttet is beszámítunk. Számold ki online, mennyit ér, majd hozd be bevizsgálásra.',
    h1: 'iPhone felvásárlás Orosházán',
    bevezeto: 'Megveszzük a használt iPhone-odat – készpénzért vagy beszámításba egy újabb készülék mellé. Az online kalkulátor pár kérdés után tájékoztató árat ad, a végleges összeg a helyszíni bevizsgálás után derül ki.',
    // Ami VALÓBAN befolyásolja egy iPhone árát – nem általánosság.
    artenyezok: [
      { cim: 'Akkumulátor állapota', szoveg: 'Az iPhone maga méri a maximális kapacitást (Beállítások → Akkumulátor). 80% alatt az ár érezhetően csökken, mert a vevőnek akkucserével kell számolnia.' },
      { cim: 'iCloud aktiválási zár', szoveg: 'Ez a legfontosabb. Zárolt készüléket nem tudunk megvenni, mert nem lehet újra használatba venni. A Find My-t eladás előtt kapcsold ki, és jelentkezz ki az iCloudból.' },
      { cim: 'Kijelző eredete', szoveg: 'Ha korábban cseréltek benne kijelzőt, a telefon jelzi („nem eredeti alkatrész”). Ez nem kizáró ok, de az árban megjelenik.' },
      { cim: 'Esztétikai állapot', szoveg: 'Karcok, horpadás, törött hátlap. Töröttet is megveszünk – az árat ilyenkor a javítási költség csökkenti.' },
    ],
    gyik: [
      { q: 'Töröttet is megvesztek?', a: 'Igen. Törött kijelzővel vagy hátlappal is hozd be – megnézzük, mennyibe kerül helyrehozni, és ennek megfelelő árat adunk. Nem küldünk el üres kézzel.' },
      { q: 'Mit vigyek magammal?', a: 'A készüléket és egy személyazonosító okmányt. A felvásárlásról papír készül. Ha megvan a töltő és a doboz, hozd azt is – kicsit emeli az árat.' },
      { q: 'Mennyivel ér többet, ha nem készpénzt kérek?', a: 'A beszámítás („Fiókpénz”) a készpénznél magasabb összeget ad, ha nálunk költöd el. A kalkulátor mindkét összeget megmutatja, és te döntesz.' },
    ],
    keszletUrl: '/hasznalt-iphone-oroshaza/',
    keszletCim: 'Használt iPhone készletünk',
    szervizUrl: '/iphone-szerviz-oroshaza/',
  },
  {
    slug: 'samsung-felvasarlas-oroshaza',
    marka: 'Samsung',
    cim: 'Samsung felvásárlás Orosházán – azonnali készpénz | NorbiPhone',
    leiras: 'Használt Samsung Galaxy felvásárlás Orosházán azonnali készpénzes kifizetéssel. Töröttet is beszámítunk. Számold ki online, mennyit ér a készüléked.',
    h1: 'Samsung felvásárlás Orosházán',
    bevezeto: 'Megvesszük a használt Samsung Galaxy készülékedet – készpénzért vagy beszámításba. Az online kalkulátor tájékoztató árat ad, a végleges összeg a helyszíni bevizsgálás után derül ki.',
    artenyezok: [
      { cim: 'Google-fiók zár (FRP)', szoveg: 'Ez a legfontosabb. Eladás előtt jelentkezz ki a Google- és a Samsung-fiókodból, és állítsd vissza gyári állapotra. Fiókzárral a készülék nem vehető újra használatba.' },
      { cim: 'Kijelző beégés', szoveg: 'A Galaxy AMOLED kijelzőin hosszú használat után beéghet a kép. Ez a legtöbb vevőnek zavaró, ezért az árban megjelenik – de nem kizáró ok.' },
      { cim: 'Modell és széria', szoveg: 'Az S széria jellemzően jobban tartja az értékét, mint az A széria. Ugyanaz az életkor két szériánál más árat jelent.' },
      { cim: 'Esztétikai állapot', szoveg: 'Karcok, horpadás, törött hátlap. Töröttet is megveszünk – az árat a javítási költség csökkenti.' },
    ],
    gyik: [
      { q: 'Törött Samsungot is megvesztek?', a: 'Igen. Hozd be – megnézzük, mennyibe kerül helyrehozni, és ennek megfelelő árat adunk.' },
      { q: 'Mit csináljak eladás előtt?', a: 'Jelentkezz ki a Google- és a Samsung-fiókodból, majd állítsd vissza gyári állapotra. Ha ebben segítség kell, az üzletben megmutatjuk.' },
      { q: 'Beszámítható újabb készülékre?', a: 'Igen. A beszámítás a készpénznél magasabb összeget ad, ha nálunk költöd el. A kalkulátor mindkét összeget megmutatja.' },
    ],
    keszletUrl: '/hasznalt-samsung-telefon-oroshaza/',
    keszletCim: 'Használt Samsung készletünk',
    szervizUrl: '/samsung-szerviz-oroshaza/',
  },
];

export const markaFelvasarlasSlugbol = (slug) =>
  MARKA_FELVASARLAS.find((m) => m.slug === slug) || null;

export const MARKA_FELVASARLAS_UTVONALAK = MARKA_FELVASARLAS.map((m) => `/${m.slug}`);
